import React from "react";
import Box from "@mui/material/Box";
import Slider from "@mui/material/Slider";

export interface MarksItem {
  value: number;
  label: string;
  amount: number;
}

interface Props {
  value: number;
  setPrice: any;
  marks: MarksItem[];
  setValue: any;
}

function ValueSlider({ setPrice, marks, value, setValue }: Props) {
  function valuetext(value: number) {
    return `${value}`;
  }

  function valueLabelFormat(value: number) {
    return marks.findIndex((mark) => mark.value === value) + 1;
  }

  const handleChange = (e: any) => {
    const idx = marks.findIndex((mark) => mark.value === e.target.value);

    setPrice(value * marks[idx].amount);
    setValue(idx);
  };

  return (
    <div>
      <Box>
        <Slider
          sx={{ width: "200px" }}
          aria-label="Select Values"
          defaultValue={35}
          valueLabelFormat={valueLabelFormat}
          getAriaValueText={valuetext}
          step={null}
          valueLabelDisplay="off"
          marks={marks}
          onChange={handleChange}
        />
      </Box>
    </div>
  );
}

export default ValueSlider;
